import React from "react";
import { Breadcrumb } from "../Breadcrumb/Breadcrumb";
import { StyledButtonLink } from "../Styled/Button";
import { BackgroundContainer, StyledContainer } from "../Styled/Container";
import { StyledH1 } from "../Styled/Text";
import { ErrorOutputProps, withError } from "./withError";
import { Sections } from "../Sections/Sections";

import { clsx } from "clsx";

const Container = (props: any) => (
  <StyledContainer
    {...props}
    className={clsx(
      props.className,
      "relative flex flex-col items-center pb-giga pt-peta",
    )}
  />
);

const Title = (props: any) => (
  <StyledH1
    {...props}
    className={clsx(props.className, "mb-mini text-center md:mb-maxi")}
  />
);

const Button = (props: any) => (
  <StyledButtonLink
    {...props}
    className={clsx(props.className, "w-full max-w-[232px] sm:max-w-[320px]")}
  />
);

export const ErrorPage = withError(
  ({ title, buttonText, buttonLink, paths, content }: ErrorOutputProps) => (
    <>
      <BackgroundContainer background="light">
        <Container>
          {paths && <Breadcrumb paths={paths} />}
          <Title>{title}</Title>
          {buttonText && buttonLink ? (
            <Button
              to={buttonLink}
              height="56"
              textSize="56"
              colour="light"
              border
            >
              {buttonText}
            </Button>
          ) : null}
        </Container>
        <Sections page={{ content }} />
      </BackgroundContainer>
    </>
  ),
);

export default ErrorPage;
